import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import ProdutoService from "../../../services/service.produto";
import NotImage from "../../../assets/sem-imagem.png";

// A rota de imagem exige token (Authorization), que a tag <img> nao envia.
// Baixa a foto pelo axios e mostra o arquivo local; sem foto ou com erro, "sem imagem".
export const ImagemProduto = ({ path, ...rest }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!path) {
      setSrc(null);
      return undefined;
    }
    let ativo = true;
    let objectUrl = null;
    ProdutoService.getImageBlob(path)
      .then((response) => {
        if (!ativo || !response.data || response.data.size === 0) return;
        objectUrl = URL.createObjectURL(response.data);
        setSrc(objectUrl);
      })
      .catch(() => {
        if (ativo) setSrc(null);
      });
    return () => {
      ativo = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  return <Image src={src || NotImage} {...rest} />;
};

export default ImagemProduto;
